import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingMarketTypeDropdown: false,
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    LOAD_MARKET_TYPE_DROPDOWN: (s, data) => (s.loadingMarketTypeDropdown = data),
  },
  actions: {
    async getMarketTypeDropdown({ commit }, { sportCode, search }) {
      commit("LOAD_MARKET_TYPE_DROPDOWN", true);
      try {
        const res = await this.$api.get(
          `/v1/portal/sport-config/crawling-markets/market-types/${encodeURIComponent(sportCode)}`,
          { params: { search } }
        );
        return res.data?.data || res.data || [];
      } catch (e) {
        errorHandler(e);
        return [];
      } finally {
        commit("LOAD_MARKET_TYPE_DROPDOWN", false);
      }
    },
  },
};
